<!--- Componente Operaciones Personalizadas ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el componente:
-----------------------
-

Eventos generados por el componente:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div
    v-if="(modoConsultaAgrupada) || personalizacionesFormularios != null"
    class="main-operacionesPersonalizadas no-padding no-margin"
    :style="appTheme"
  >
    <UCPreload
      v-if="mostrarPrecarga"
      :show="preloader"
      :numero-elementos="1"
      :numero-loaders="numeroDeLoaders"
    />
    <div
      v-if="!preloader && operacionesPersonalizadas != null"
      class="no-padding no-margin"
    >
      <!-- Controlar que sea un botón o un texto o una tabla -->
      <div
        v-for="(item, j) in operacionesPersonalizadas"
        :key="j"
        class="container  no-padding no-margin"
      >
        <!-- 0: boton, 1: texto, 2: tabla, 3: concatenación -->
        <!-- BOTON -->
        <div
          v-if="(permitirBoton) && item.TipoComponente === 0 && item.Icono"
          class="item seleccionable"
          :class="{
            'disabled': (item.Deshabilitado === 1 || item.Deshabilitado === true || item.Deshabilitado === 'True' ? true : false),
            'btn-no-activo': (item.Valor === 0 || item.Valor === 'False' ? true : false),
          }"
          :Style="(item.Estilos != null ? item.Estilos : null)"
          @click="ClickOperacion(item)"
        >
          <img
            v-if="item.Icono"
            alt="iconImgUrl"
            class="img-center"
            :src="getImgUrl(item.Icono)"
            width="20"
            height="20"
          >
          <span class="item-nombre">
            {{ item.Nombre }}</span>
        </div>
        <div
          v-if="(permitirBoton) && item.TipoComponente === 0 && !item.Icono"
          class="item-flex seleccionable"
          :class="{
            'disabled': (item.Deshabilitado === 1 || item.Deshabilitado === true || item.Deshabilitado === 'True' ? true : false),
            'btn-no-activo': (item.Valor === 0 || item.Valor === 'False' ? true : false),
          }"
          :Style="(item.Estilos != null ? item.Estilos : null)"
          @click="ClickOperacion(item)"
        >
          <span class="item-nombre">
            {{ item.Nombre }}</span>
        </div>
        <!-- TEXTO -->
        <div
          v-if="(permitirTexto) && item.TipoComponente === 1 && item.Valor !== null"
          class="span-text margin-half"
          :Style="(item.Estilos != null ? item.Estilos : null)"
        >
          <span> {{ item.Valor }} </span>
        </div>
        <!-- TABLA -->
        <div v-if="(permitirTabla) && item.TipoComponente === 2 && item.Valor.length !== 0">
          <div
            v-for="(dato, i) in item.Valor"
            :key="i"
            class="data-table margin-half"
            :Style="(item.Estilos != null ? item.Estilos : null)"
          >
            <table v-if="dato.Valor !== null">
              <tbody>
                <tr>
                  <td
                    v-for="(items, k) in dato"
                    :key="k"
                  >
                    <span> {{ items }} </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- CONCATENACION -->
        <div
          v-if="(permitirConcatenacion) && item.TipoComponente === 3 && item.Valor.length !== 0"
          class="no-padding no-margin"
          :Style="(item.Estilos != null ? item.Estilos : null)"
        >
          <div
            v-for="(stringDatos, i) in item.Valor"
            :key="i"
          >
            <span
              v-if="stringDatos.Valor != null"
              class="span-concatenacion"
              :Style="(item.Estilos != null ? item.Estilos : null)"
            > {{ getString(stringDatos) }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';

import { Log } from '@/js/common/HIDebuggingSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import {
  ConfirmDialogGH,
  HiDialog,
  HiNotification,

} from '@/js/common/HINotificationSupport';
import ConexionERP from '@/js/services/APIErp';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';

export default {
  name: 'PCOperacionesPersonalizadas',
  components: {
    UCPreload,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    entidad: {
      type: Object,
      default: null,
    },
    parametros:
    {
      type: Array,
      default: () => [],
    },
    formularioPadre: {
      type: String,
      default: null,
    },
    tipoEntidad: {
      type: Number,
      default: 0, // 0 --> Punto Paletizado, 1 --> Partidas, 2 --> zzzzz
    },
    mostrarPrecarga: {
      type: Boolean,
      default: true,
    },
    componenteAplicacion: {
      type: String,
      default: '',
    },
    numeroDeLoaders: {
      type: Number,
      default: 3,
    },
    separador: {
      type: String,
      default: '→',
    },
    noPermitidos: {
      type: Array,
      default: null,
    }, // ['boton', 'texto', 'tabla', 'concatenacion'] Array con lo que no se permite

    modoConsultaAgrupada: { // para evitar llamadas masivas
      type: Boolean,
      default: false,
    },

    datos: { // Array con las personalizaciones en caso de consulta agrupada
      type: Array,
      default: null,
    },

  },

  emits: [
    'action-ok',
    'action-ko',
    'action-end',
  ],

  data() {
    return {
      objEntidadSeleccionada: null,
      operacionesPersonalizadas: null,
      preloader: false,
      permitirBoton: true,
      permitirTabla: true,
      permitirTexto: true,
      permitirConcatenacion: true,
    };
  },
  computed: {
    ...mapState(useAppConfigStore, ['personalizacionesFormularios']),

    appTheme() {
      return {
        '--f7-table-cell-padding-horizontal': '18px',
      };
    },
  },
  watch: {
    activo(val) {
      if (val && this.entidad != null) {
        this.InicializarComponent();
      } else {
        this.RestablecerComponent();
      }
    },
    async entidad(val) {
      if (val != null) {
        this.InicializarComponent();
      } else {
        this.RestablecerComponent();
      }
    },
    async datos(val) {
      if (val != null) {
        this.InicializarComponent();
      } else {
        this.RestablecerComponent();
      }
    },
  },
  mounted() {
    this.InicializarComponent();
  },

  methods: {
    InicializarComponent() {
      Log(this, this.InicializarComponent.name);
      if (this.personalizacionesFormularios === null) {
        return;
      }
      if (!this.modoConsultaAgrupada) {
        this.ComprobarComponentesFormulario();
      } else {
        this.InicializarComponenteAgrupado();
      }
    },

    RestablecerComponent() {
      this.objEntidadSeleccionada = null;
      this.datosAuxiliares = [];
    },
    async InicializarComponenteAgrupado() {
      Log(this, this.InicializarComponenteAgrupado.name);
      this.preloader = true;
      this.operacionesPersonalizadas = [];
      this.objEntidadSeleccionada = this.entidad;
      if (this.entidad != null && this.activo && Array.isArray(this.datos)) {
        const operaciones = this.datos.filter((e) => e.Entidad.Id === this.entidad.Id);
        if (operaciones.length > 0) {
          this.operacionesPersonalizadas = [];
          operaciones.forEach((element) => {
            this.operacionesPersonalizadas.push({ ...element.OperacionesPersonalizadas[0] });
          });

          this.ElementosPermitidos();
        }
      }
      this.preloader = false;
    },

    /* async InicializarComponenteAgrupado() {
      Log(this, this.InicializarComponenteAgrupado.name);
      this.preloader = true;
      this.operacionesPersonalizadas = [];

      if (this.entidad != null && this.activo && Array.isArray(this.datos)) {
        let operaciones = this.datos.filter((e) => e.Entidad.Id === this.entidad.Id);
        if (operaciones.length > 0) {
          const tempEntidades = {};
          operaciones = operaciones.filter((f) => {
            if (!tempEntidades[f.Entidad.Id]) {
              tempEntidades[f.Entidad.Id] = true;
              return true;
            }
            return false;
          });

          operaciones.forEach((element) => {
            this.operacionesPersonalizadas.push(element.OperacionesPersonalizadas[0]);
          });
          // this.operacionesPersonalizadas = operaciones[0].OperacionesPersonalizadas;
          this.ElementosPermitidos();
        }
      }
      this.preloader = false;
    }, */

    ElementosPermitidos() {
      Log(this, this.ElementosPermitidos.name);
      if (this.noPermitidos != null) {
        this.noPermitidos.forEach((element) => {
          if (element === 'boton') {
            this.permitirBoton = false;
          }
          if (element === 'texto') {
            this.permitirTexto = false;
          }
          if (element === 'tabla') {
            this.permitirTabla = false;
          }
          if (element === 'concatenacion') {
            this.permitirConcatenacion = false;
          }
        });
      }
    },

    ComprobarComponentesFormulario() {
      Log(this, this.ComprobarComponentesFormulario.name);

      if (this.personalizacionesFormularios != null) {
        this.personalizacionesFormularios.forEach((e) => {
          if (e.Formulario === this.formularioPadre) {
            e.ElementosPersonalizados.forEach((element) => {
              element.ComponentesDeAplicacion.forEach((componente) => {
                if (componente === this.componenteAplicacion) {
                  this.ElementosPermitidos();
                  if (this.entidad != null && this.activo) {
                    this.ObtenerOperacionesPersonalizadasEntidad(this.entidad);
                  }
                }
              });
            });
          }
        });
      }
    },

    /** * Método ObtenerOperacionesPersonalizadasEntidad */
    async ObtenerOperacionesPersonalizadasEntidad(objEntidad) {
      Log(this, this.ObtenerOperacionesPersonalizadasEntidad.name);
      this.preloader = true;
      this.objEntidadSeleccionada = objEntidad;
      this.operacionesPersonalizadas = await this.Conexion_ObtenerOperacionesPersonalizadasEntidad({ Id: objEntidad.Id });
      this.preloader = false;
    },
    getImgUrl(path) {
      const images = import.meta.webpackContext('@/static/icons/');
      return images(`./${path}`);
    },

    FormatDate(dateTime) {
      return HiDateTimeSupport.FormatDateTime(dateTime, 'DD/MM/YYYY HH:mm:ss');
    },
    getString(stringDatos) {
      let string = `${stringDatos.NombreColumna} ${this.separador} ${stringDatos.Valor},`;
      if (stringDatos.NombreColumna.includes('Fecha')) {
        string = `${stringDatos.NombreColumna} ${this.separador} ${this.FormatDate(stringDatos.Valor)},`;
      }
      return string.substring(0, string.length - 1);
    },
    async ClickOperacion(botonPersonalizacion) {
      if (botonPersonalizacion.ConfirmacionPreviaAccion === undefined || botonPersonalizacion.ConfirmacionPreviaAccion) {
        const resultConfirm = await ConfirmDialogGH(this.$t('production.customOperations.click.confirmationAlert.text'), botonPersonalizacion.Nombre);
        if (!resultConfirm) {
          return;
        }
      }
      if (botonPersonalizacion.PreloaderBloqueante) {
        HiDialog.Preloader(true, this.$t('production.customOperations.click.loading.preloaderText', { name: botonPersonalizacion.Nombre }));
      }

      this.preloader = true;
      const res = await this.Conexion_EjecutarAccionPersonalizada(botonPersonalizacion.AccionEjecucion);
      if (res) {
        this.$emit('action-ok');
      } else {
        this.$emit('action-ko');
        HiNotification.Toast(this.$t('production.customOperations.click.loading.errorToastText'));
      }
      this.operacionesPersonalizadas = await this.Conexion_ObtenerOperacionesPersonalizadasEntidad({ Id: this.objEntidadSeleccionada.Id });
      this.preloader = false;

      if (botonPersonalizacion.PreloaderBloqueante) {
        HiDialog.Preloader(false);
      }
      this.$emit('action-end');
    },

    async Conexion_ObtenerOperacionesPersonalizadasEntidad(objEntidad) {
      Log(this, this.Conexion_ObtenerOperacionesPersonalizadasEntidad.name);
      try {
        const consultaPersonalizacionApp = {
          TipoEntidad: this.tipoEntidad,
          ComponenteDeAplicacion: this.componenteAplicacion,
          Formulario: this.formularioPadre,
          Entidad: objEntidad,
        };
        const result = await ConexionERP.callObtenerOperacionesPersonalizadasEntidad(consultaPersonalizacionApp);
        if (result.data.Valor) {
          return JSON.parse(result.data.Mensaje);
        }
      } catch {
        /*  LogError(this, this.Conexion_ObtenerOperacionesPersonalizadasEntidad.name, error); */
        HiNotification.Toast(this.$t('common.checkYourConnection'));
      }
      return [];
    },

    async Conexion_EjecutarAccionPersonalizada(accionEjecucion) {
      Log(this, this.Conexion_EjecutarAccionPersonalizada.name);
      try {
        const result = await ConexionERP.callEjecurarAccionPersonalizada(accionEjecucion, this.parametros);
        return result.data.Valor;
      } catch {
        // LogError(this, this.Conexion_EjecutarAccionPersonalizada.name, error);
        HiNotification.Toast(this.$t('common.checkYourConnection'));
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
.main-operacionesPersonalizadas {
  .div-cabeceraTitulo {
    color: #24253d;
    text-transform: none;
    font-family: Roboto;
    font-size: 22px;
    background: var(--his-tierra-white);
    padding-left: 25px;
    border-bottom: 4px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-color: var(--his-disabled);
    border-style: solid;
  }

  .container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: left;
    align-items: baseline;
    align-content: stretch;
  }

  /* BOTON */
  .item {
    flex-grow: 4; /* default 0 */
    margin-left: 2%;
    display: grid;
    padding: 10px;
    text-align: center;
    border-radius: 10px;
    background-color: #333; /** TODO Temporal **/
    min-height: 49px;
    margin-right: 2%;
    margin-top: 10px;
    font-family: Roboto;
    color: var(--his-ash-gray);
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
  }

  .item-flex {
    flex-grow: 4; /* default 0 */
    display: flex;
    justify-content: center;
    padding: 10px;
    margin-left: 2%;
    text-align: center;
    border-radius: 10px;
    background-color: #333; /** TODO Temporal **/
    min-height: 49px;
    margin-right: 2%;
    margin-top: 10px;
    font-family: Roboto;
    color: var(--his-ash-gray);
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
  }

  .item-valor {
    color: var(--his-darkgray);
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    text-align: center;
  }

  // .item-nombre {
  //   font-family: Roboto;
  //     color: var(--his-ash-gray);
  //     font-size: 14px;
  //     font-weight: 400;
  //     line-height: 16px;
  // }

  .disabled {
    opacity: 0.6;
    pointer-events: none;
  }

  .btn-no-activo {
    background-color: #c5c6c7;
  }

  .img-center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
  }

  /* TEXTO */
  .span-text {
    color: var(--his-dark-blue);
    font-size: 16px;
  }

  /* TABLA */
  .data-table {
    color: var(--his-dark-blue);
  }

  /* PERSONALIZADO */
  .span-concatenacion {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-size: 13px;
    color: var(--his-dark-blue);
  }
}
</style>
